export default function isAllowedEmail(value, allowedDomainList) {
  if (allowedDomainList.length > 0) {
    if (
      !allowedDomainList.some(
        (x) => x.toLowerCase() === value.split("@")[1].toLowerCase()
      )
    )
      return "Please enter your assistant's Allstate email address";
  }
}
